exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-select-form {\n  border: none;\n  padding: 0; }\n  .admin-select-form .section-heading {\n    margin-bottom: 20px;\n    margin-left: -20px; }\n    .admin-select-form .section-heading h2 {\n      margin-bottom: 5px !important;\n      padding-left: 20px; }\n    .admin-select-form .section-heading p i {\n      padding-left: 20px;\n      font-weight: 300; }\n  .admin-select-form .selected-users h2 {\n    margin: 7px 0; }\n  .admin-select-form .selected-users .col-sm-11 {\n    padding: 0; }\n  .admin-select-form .selected-users .col-sm-1 {\n    text-align: center;\n    padding: 8px; }\n  .admin-select-form .oi-trash {\n    cursor: pointer;\n    color: #5B6779; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/forms/components/admin-select-form/admin-select-form.component.scss
// module id = ../../../../../src/app/forms/components/admin-select-form/admin-select-form.component.scss
// module chunks = 12